/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Agents_Mock_4_DetailInputs */

const en_cap_agents_mock_4_detail = /** @type {(inputs: Cap_Agents_Mock_4_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign off`)
};

const lv_cap_agents_mock_4_detail = /** @type {(inputs: Cap_Agents_Mock_4_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apstiprināt`)
};

/**
* | output |
* | --- |
* | "Sign off" |
*
* @param {Cap_Agents_Mock_4_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_agents_mock_4_detail = /** @type {((inputs?: Cap_Agents_Mock_4_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Agents_Mock_4_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_agents_mock_4_detail(inputs)
	return en_cap_agents_mock_4_detail(inputs)
});